export default "__VITE_ASSET__3ee59a07__"